import localePl from '@angular/common/locales/pl';
import localeEn from '@angular/common/locales/en-GB';
import { APP_INITIALIZER, DEFAULT_CURRENCY_CODE, LOCALE_ID, NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import enVocab from 'panel-frontend-i18n/vocabs/en.json';
import plVocab from 'panel-frontend-i18n/vocabs/pl.json';
import enCountries from 'i18n-iso-countries/langs/en.json';
import plCountries from 'i18n-iso-countries/langs/pl.json';
import 'moment/locale/pl';

import { ILocale } from './i18n.types';
import { I18nService } from './i18n.service';
import { DEFAULT_LANG, DEFAULT_LOCALE, LOCALE_DATE_FORMATS, LOCALES } from './i18n.config';

const defaultLang = 'pl';
const defaultLocale = 'pl';
const defaultCurrency = 'PLN';

const locales: ILocale[] = [
  {
    localeId: 'pl',
    lang: 'pl',
    name: 'Polski',
    flag: './assets/media/flags/poland.svg',
    vocabulary: plVocab.data,
    countries: plCountries.countries,
    localeData: localePl,
    dateFormats: {
      shortDate: 'dd.MM.yyyy',
      short: 'dd.MM.yyyy, HH:mm',
      shortTime: 'HH:mm',
    },
  },
  {
    localeId: 'en-US',
    lang: 'en',
    name: 'English',
    flag: './assets/media/flags/united-states.svg',
    vocabulary: enVocab.data,
    countries: enCountries.countries,
    localeData: localeEn,
    dateFormats: {
      shortDate: 'M/d/yyyy',
      short: 'M/d/yyyy, HH:mm',
      shortTime: 'HH:mm',
    },
  },
]

@NgModule({
  imports: [
    TranslateModule.forRoot(),
  ],
  exports: [
    TranslateModule,
  ],
  declarations: [],
  providers: [
    { provide: DEFAULT_LANG, useValue: defaultLang },
    { provide: DEFAULT_LOCALE, useValue: defaultLocale },
    { provide: LOCALES, useValue: locales },
    {
      provide: APP_INITIALIZER,
      useFactory: (translationService: I18nService) => translationService.init,
      multi: true,
      deps: [I18nService]
    },
    {
      provide: LOCALE_ID,
      useFactory: (translationService: I18nService) => translationService.getSelectedLocaleId(),
      deps: [I18nService]
    },
    {
      provide: LOCALE_DATE_FORMATS,
      useFactory: (translationService: I18nService) => translationService.selectedLocaleFull!.dateFormats,
      deps: [I18nService],
    },
    {
      provide: DEFAULT_CURRENCY_CODE,
      useValue: defaultCurrency,
    },
    I18nService,
  ],
})
export class I18nModule {}
